import ApplicationController from '../application_controller';

// Connects to data-controller="administrators--newsletter"
export default class extends ApplicationController {
  static targets = ['checkbox', 'subject'];

  connect() {
    super.connect();

    this.toggleSubject(this.checkboxTarget);
  }

  toggleSubject(eventOrElement) {
    // const { currentTarget } = event;
    const checkbox = eventOrElement.currentTarget ?? eventOrElement;

    if (checkbox.value !== 'email') return;

    if (checkbox.checked) {
      this.showSubject();
    } else {
      this.hideSubject();
    }
  }

  showSubject() {
    this.subjectTarget.classList.remove('d-none');
  }

  hideSubject() {
    this.subjectTarget.classList.add('d-none');
  }
}
